


















import { listFactory } from '@/main/pages/listFactory';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store);
